<template>
  <div class="qr-list">
    <page-header
      :title="'QR - ' + toLatin(restaurantName)"
      :subtitle="$t('qr_codes_list')"
      icon="mdi-qrcode-scan"
      icon-color="primary"
    >
      <template #actions>
        <v-btn color="primary" depressed @click="printSinglePage">
          <v-icon>mdi-printer</v-icon>
          {{ $t("print") }}
        </v-btn>
      </template>
    </page-header>

    <company-employees-qr-table
      :employees="currentItems"
      :restaurantName="restaurantName"
      :show-print-settings="isEmployeeRoute"
      @cardUpdated="card = $event"
    >
      <v-col
        cols="auto"
        v-if="
          children &&
          children.length > 0 &&
          parentCompanies.length &&
          parentCompanies.find((company) => company.parent_id == 0).id == idProp
        "
      >
        <autocomplete
          v-model="companyChildren"
          :items="parentCompanies || []"
          multiple
          item-text="name"
          item-value="id"
          @input="addUsersToParentCompany()"
          :label="$t('select_company')"
          hide-details
          color="white"
          chips
          small-chips
          style="min-width: 300px"
        >
          <v-btn
            color="primary"
            slot="prepend-item"
            @click="addAllUsersToParent()"
            small
            class="mx-4"
          >
            {{ $t("display_all") }}
          </v-btn>
        </autocomplete>
      </v-col>
    </company-employees-qr-table>

    <div class="px-6 mt-2">
      <v-data-table
        id="qrTable"
        :headers="headers"
        :items="tableEmployees"
        class="ordera-box-shadow striped-table"
        mobile-breakpoint="0"
        :loading="loading"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        hide-default-footer
        @current-items="currentItems = $event"
        @page-count="pageCount = $event"
      >
        <!-- QR Code Column -->
        <template v-slot:item.qrCode="{ item, index }">
          <div class="d-flex justify-center pt-2 pb-1">
            <div
              class="qr-code-container"
              @click="singleQrPrint(item, index)"
              :title="$t('click_to_print')"
            >
              <qrcode-vue
                :id="`qrkodstampa${item.id}`"
                :value="item.qrCode"
                :size="120"
                level="H"
                render-as="svg"
                class="qr-code"
              />
            </div>
          </div>
        </template>

        <template v-slot:item.name="{ item }">
          {{ toLatin(item.name) }}
        </template>
        <template v-slot:item.lastname="{ item }">
          {{ toLatin(item.lastname) }}
        </template>
        <!-- Type Column -->
        <template v-slot:item.type="{ item }">
          <v-chip
            :color="item.type === 'customer' ? 'primary' : 'secondary'"
            text-color="white"
            small
          >
            <v-icon left x-small>
              {{ item.type === "customer" ? "mdi-account" : "mdi-domain" }}
            </v-icon>
            {{ item.type === "customer" ? $t("employee") : $t("firm") }}
          </v-chip>
        </template>
      </v-data-table>
      <v-row align="center" justify="end" no-gutters class="mt-4">
        <text-field
          :value="itemsPerPage"
          :label="$t('employees_per_page')"
          type="number"
          :min="1"
          @input="itemsPerPage = parseInt($event, 10)"
        ></text-field>
        <v-pagination class="ml-4" v-model="page" :length="pageCount"></v-pagination>
      </v-row>
    </div>
  </div>
</template>

<script>
import conf from "@/config";
import CompanyEmployeesQrTable from "@/components/company/employee/tables/CompanyEmployeesQrTable.vue";
import QrcodeVue from "qrcode.vue";
import PageHeader from "@/components/global/PageHeader.vue";
import PageToolbar from "@/components/global/PageToolbar.vue";
import companyService from "@/services/company";
import restaurantService from "@/services/restaurant";
import hasSnackbar from "@/mixins/hasSnackbar";

export default {
  mixins: [hasSnackbar],
  props: ["idProp"],
  components: {
    CompanyEmployeesQrTable,
    QrcodeVue,
    PageHeader,
    PageToolbar,
  },
  data: () => ({
    conf: conf,
    restaurantName: "",
    employees: [],
    companyChildren: [],
    parentCompanies: [],
    children: "",
    loading: false,
    usersOriginal: [],
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    currentItems: [],
    search: "",
    card: {
      search: "",
      width: "90",
      height: "50",
      marginTop: "25",
      fontSize: "13",
      type: 2,
      visible_fields: [1, 2, 3, 4],
    },
  }),

  created() {
    if (this.$route.params.res) {
      this.initializeRes();
    } else if (this.$route.params.jela) {
      this.initializeJela();
    } else {
      this.initialize();
    }
    if (this.$route.params.children) {
      this.children = this.$route.params.children;
    }
    if (this.$route.params.parentCompanies) {
      this.parentCompanies = this.$route.params.parentCompanies;
    }
  },

  methods: {
    addAllUsersToParent() {
      if (this.companyChildren.length > 0) {
        this.companyChildren = [];
        this.addUsersToParentCompany();
      } else if (this.companyChildren.length == 0) {
        let allFirmsId = [];
        this.parentCompanies.filter((firm) => {
          allFirmsId.push(firm.id);
        });
        this.companyChildren = allFirmsId;
        this.addUsersToParentCompany();
      }
    },
    addUsersToParentCompany() {
      let users = "";
      if (this.companyChildren.length > 0) {
        users = [];
        this.parentCompanies.filter((item) => {
          if (item.users && item.users.length > 0) {
            item.users.filter((user, index) => {
              if (this.companyChildren.includes(user.pivot.company_id)) {
                users.push(user);
              }
            });
          }
        });
      }
      if (this.companyChildren.length == 0) {
        users = this.usersOriginal;
      }
      this.employees = users;
      this.$forceUpdate();
    },
    initialize() {
      this.loading = true;
      companyService
        .getCompanyUsers(this.id)
        .then((res) => {
          this.restaurantName = res.data.name;
          res.data.users.forEach((el, index) => {
            // el.rb = index + 1

            if (typeof el.qrCode === "object" && el.qrCode !== null) {
              el.qrCode = JSON.stringify(el.qrCode);
            }
            this.employees.push(el);
            this.usersOriginal.push(el);
            this.parentCompanies.filter((itm) => {
              if (itm.id == res.data.id) {
                itm.users = res.data.users;
              }
            });
          });
        })
        .catch((error) => {
          this.showErrorSnackbar(this.$t("error_loading_company_users"));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    initializeRes() {
      restaurantService.getRestaurantUsers(this.$route.params.res).then((res) => {
        this.restaurantName = res.data.name;
        res.data.users.forEach((el, index) => {
          // el.rb = index + 1
          this.employees.push(el);
          this.usersOriginal.push(el);
        });
      });
    },
    initializeJela() {
      restaurantService.getRestaurantFoods(this.$route.params.jela).then((res) => {
        this.restaurantName = res.data.name;
        res.data.foods.forEach((el, index) => {
          // el.rb = index + 1
          this.employees.push(el);
          this.usersOriginal.push(el);
        });
      });
    },
    printSinglePage() {
      this.loading = true;
      const width = Number(this.card.width);
      const height = Number(this.card.height);
      const doc = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: [width, height],
      });
      doc.setFont("Roboto", "normal");
      const addEmployeePage = (employee, isFirst) => {
        let id = employee.id;
        let email = employee.email || "";
        let qrCodeElem = document.getElementById("qrkodstampa" + id);
        let svg = qrCodeElem ? qrCodeElem.querySelector("svg") : null;
        if (
          !svg &&
          qrCodeElem &&
          qrCodeElem.tagName &&
          qrCodeElem.tagName.toLowerCase() === "svg"
        ) {
          svg = qrCodeElem;
        }
        if (!svg) return;

        // Convert SVG to PNG using html2canvas
        // Create a temporary container for html2canvas
        let tempDiv = document.createElement("div");
        tempDiv.style.position = "fixed";
        tempDiv.style.left = "-9999px";
        tempDiv.appendChild(svg.cloneNode(true));
        document.body.appendChild(tempDiv);

        // Use html2canvas to render SVG to image
        // html2canvas returns a Promise
        // We'll collect all promises and then save the PDF after all are done
        return html2canvas(tempDiv, {
          backgroundColor: null,
          useCORS: true,
          scale: 3,
        }).then((canvas) => {
          const imgData = canvas.toDataURL("image/png");
          document.body.removeChild(tempDiv);
          if (!isFirst) doc.addPage([width, height], "landscape");
          if (this.card.visible_fields.length < 3) {
            const qrSize = height * 0.6;
            doc.addImage(imgData, "PNG", 2, height / 2 - qrSize / 2, qrSize, qrSize);
            const rightColumnSize = width - qrSize - 10; // 10mm margin
            const fontSize = Math.floor(rightColumnSize / 2);
            const smallFontSize = Math.floor(rightColumnSize / 3);
            let offsetY = 4 + height / 2 - qrSize / 2;
            let lineHeight = Math.floor(Number(fontSize) / 2);
            doc.setFontSize(Number(fontSize));
            if (this.card.visible_fields.includes(2)) {
              doc.text(this.toLatin(employee.name), qrSize + 4, offsetY);
              offsetY += lineHeight;
              doc.text(this.toLatin(employee.lastname), qrSize + 4, offsetY);
              offsetY += lineHeight;
            }
            doc.setFontSize(Number(smallFontSize));
            if (this.card.visible_fields.includes(3)) {
              doc.text(email, qrSize + 4, offsetY);
              offsetY += lineHeight;
            }
            if (this.card.visible_fields.includes(1)) {
              doc.text(`Ordera ID: ${id}`, qrSize + 4, offsetY);
              offsetY += lineHeight;
            }
            if (this.card.visible_fields.includes(4) && employee.external_code) {
              doc.text(
                `${this.$t("access_card_id")}: ${employee.external_code}`,
                qrSize + 4,
                offsetY
              );
            }
          } else {
            const qrSize = height * 0.4;
            const rightColumnSize = width - qrSize - 10; // 10mm margin
            const fontSize = Math.floor(rightColumnSize / 3);
            const smallFontSize = Math.floor(rightColumnSize / 4);
            const offsetQr = (width - qrSize) / 2;
            let offsetY = 2;
            doc.addImage(imgData, "PNG", offsetQr, offsetY, qrSize, qrSize);
            let lineHeight = Math.floor(Number(fontSize) / 2);
            offsetY += qrSize + 3;
            const centerX = width / 2;
            doc.setFontSize(Number(fontSize));
            if (this.card.visible_fields.includes(2)) {
              doc.text(
                [employee.name, employee.lastname].map(this.toLatin).join(" "),
                centerX,
                offsetY,
                {
                  align: "center",
                }
              );
              offsetY += lineHeight;
            }
            doc.setFontSize(Number(smallFontSize));
            if (this.card.visible_fields.includes(3)) {
              doc.text(email, centerX, offsetY, {
                align: "center",
              });
              offsetY += lineHeight;
            }
            if (this.card.visible_fields.includes(1)) {
              doc.text(`Ordera ID: ${id}`, centerX, offsetY, {
                align: "center",
              });
              offsetY += lineHeight;
            }
            if (this.card.visible_fields.includes(4) && employee.external_code) {
              doc.text(
                `${this.$t("access_card_id")}: ${employee.external_code}`,
                centerX,
                offsetY,
                { align: "center" }
              );
            }
          }
        });
      };

      // Collect all html2canvas promises
      let promises = this.filteredEmployees.map((employee, idx) =>
        addEmployeePage(employee, idx === 0)
      );
      Promise.all(promises)
        .then(() => {
          // Open PDF in new window/tab instead of downloading
          const pdfUrl = doc.output("bloburl");
          window.open(pdfUrl, "_blank");
        })
        .catch((err) => {
          // Optionally, show error to user
          console.error("PDF generation error", err);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    singleQrPrint(item, index) {
      let isTable = this.employees.every((i) => i.company && i.company.type === "table");
      let column = isTable ? 4 : this.card.type == 2 ? 2 : 1;

      let html = "<table>";
      let i = 1;

      if (index % column === 0) {
        i = 1;
        html += "<tr>";
      }
      let employeeQr = document.getElementById("qrkodstampa" + item.id);
      let id = item.id;
      let name = this.toLatin([item.name, item.lastname].filter(Boolean).join(" "));
      let email = item.email || "";

      let style2 =
        index % column === 0
          ? "border-left: 1px solid rgba(0, 0, 0, 0.04); padding-right: 6px"
          : "padding-right: 6px";
      let canvas = employeeQr.getElementsByTagName("svg");

      const serializer = new XMLSerializer();
      const svgString = serializer.serializeToString(canvas[0]);
      const encodedData = "data:image/svg+xml," + encodeURIComponent(svgString);
      html += '<td style="' + style2 + '">';
      html += `<img src="${encodedData}" style="padding-left: ${
        this.card.marginTop
      }px;width: ${this.card.width * 0.4}mm; height: ${this.card.width * 0.4}mm"/>`;
      if (isTable)
        html += `<div style="font-size: ${this.card.fontSize}px; text-align: center">${name}</div>`;
      html += "</td>";

      let style =
        index % column === 0
          ? "border-right: 1px solid rgba(0, 0, 0, 0.04);"
          : "border-right: 1px solid rgba(0, 0, 0, 0.04);";

      if (!isTable) {
        html += '<td style="' + style + '">';
        html += `<div style="margin-left: 10px;display: flex; flex-direction: column; height: ${
          this.card.height
        }mm; justify-content: center; width: ${this.card.width * 0.6}mm;">`;
        html += `<div style="height: ${
          this.card.marginTop === "auto"
            ? this.card.height * 0.4 - 15
            : this.card.height - this.card.marginTop
        }mm; line-height: 1.5">`;
        html += `<div style="font-size: ${this.card.fontSize}px">${id}</div>`;
        html += `<div style="font-size: ${this.card.fontSize}px">${name}</div>`;
        html += `<div>${email}</div>`;
        html += `</div>`;
        html += `<div style="text-align: end"><span style="margin-right: 10px; color: #f1f1f1">ordera.app</span> <img src="https://restorani.bitlab.host/img/o.png" width="30px" style="margin-bottom: -4px; margin-right: ${this.card.marginTop}px"/></div>`;
        html += `</div>`;
        html += "</td>";
      }

      if (i === column) html += "</tr>";
      i++;
      // })
      html += "</table>";

      html = [
        "<!DOCTYPE html>" + "<html>",
        "   <head>",
        "   <style>td{border-bottom: 1px solid rgba(0, 0, 0, 0.04);}</style>",
        "   </head>",
        '   <body onload="window.print()" onafterprint="window.close()" style="font-family: Roboto, sans-serif; font-size: ' +
          (this.card.fontSize - 2) +
          'px!important;">',
        html,
        "   </body>",
        "</html>",
      ].join("");
      let win = window.open("", "", "left=0,top=0,toolbar=0,scrollbars=0,status=0");
      win.document.open();
      win.document.write(html);
      win.document.close();
    },
  },
  computed: {
    isFoodRoute() {
      return this.$route.params.jela !== undefined;
    },
    isResRoute() {
      return this.$route.params.res !== undefined;
    },
    isEmployeeRoute() {
      return !this.isFoodRoute && !this.isResRoute;
    },
    tableEmployees() {
      return this.customSearch(this.employees, this.headers, this.card.search);
    },
    id() {
      if (this.$store.state.company) {
        return this.$store.state.company.id;
      } else if (this.$route.params.idProp) {
        return this.$route.params.idProp;
      } else if (this.$route.params.id) {
        return this.$route.params.id;
      } else {
        return this.idProp;
      }
    },
    headers() {
      return [
        {
          text: "Id",
          value: "id",
        },
        {
          text: this.$t("external_code"),
          value: "external_code",
        },
        {
          text: this.$t("name"),
          value: "name",
        },
        {
          text: this.$t("last_name"),
          value: "lastname",
        },
        {
          text: this.$t("ek"),
          value: "email",
        },
        {
          text: this.$t("role"),
          value: "type",
          align: "center",
        },
        {
          text: this.$t("qr_code"),
          value: "qrCode",
          sortable: false,
          align: "center",
        },
      ];
    },
  },
};
</script>
